import { render, staticRenderFns } from "./PcaPlotResult.vue?vue&type=template&id=4032d328&scoped=true"
import script from "./PcaPlotResult.vue?vue&type=script&lang=js"
export * from "./PcaPlotResult.vue?vue&type=script&lang=js"
import style0 from "./PcaPlotResult.vue?vue&type=style&index=0&id=4032d328&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4032d328",
  null
  
)

export default component.exports